import React, { useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { Button } from "@mui/material";
import { useExpenseInvoiceContext } from "../../context/ExpenseInvoiceContext";
import { Link } from "react-router-dom";
import "./expenseInvoices.css";

const ExpenseInvoices = () => {
  const {
    expenseInvoices,
    fetchExpenseInvoices,
    deleteExpenseInvoice,
    loading,
  } = useExpenseInvoiceContext();

  useEffect(() => {
    fetchExpenseInvoices();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("هل أنت متأكد من حذف فاتورة الصرف؟")) {
      try {
        const response = await deleteExpenseInvoice(id);
        if (response.status === "success") {
          alert("✅ تم حذف فاتورة الصرف بنجاح");
          fetchExpenseInvoices();
        }
      } catch (err) {
        alert(err.response?.data?.message || "حدث خطأ أثناء حذف فاتورة الصرف");
      }
    }
  };

  const columns = [
    {
      accessorKey: "id",
      header: "رقم الفاتورة",
      size: 150,
      Cell: ({ row }) => (
        <Link
          to={`/expense-invoice/${row.original.id}`}
          style={{
            color: "#0066ff",
            fontWeight: 600,
            textDecoration: "none",
          }}
        >
          #{row.original.id}
        </Link>
      ),
    },
    {
      accessorKey: "title",
      header: "العنوان",
      size: 220,
      Cell: ({ cell }) => (
        <span style={{ fontWeight: 500 }}>{cell.getValue()}</span>
      ),
    },
    {
      accessorKey: "description",
      header: "الوصف",
      size: 300,
      Cell: ({ cell }) => cell.getValue() || "-",
    },
    {
      accessorKey: "amount",
      header: "المبلغ",
      size: 150,
      Cell: ({ cell }) => (
        <span style={{ color: "#2563eb", fontWeight: 600 }}>
          {parseFloat(cell.getValue()).toFixed(2)} ₪
        </span>
      ),
    },
    {
      accessorKey: "created_at",
      header: "التاريخ",
      size: 160,
      Cell: ({ cell }) => {
        const date = new Date(cell.getValue());
        return date.toLocaleDateString("ar-EG");
      },
    },
    {
      accessorKey: "actions",
      header: "الإجراءات",
      enableSorting: false,
      Cell: ({ row }) => (
        <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
          <Link
            to={`/expense-invoice/edit/${row.original.id}`}
            style={{
              padding: "6px 12px",
              backgroundColor: "#3b82f6",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "13px",
              fontWeight: "500",
              textDecoration: "none",
              display: "inline-block",
            }}
          >
            تعديل
          </Link>
          <button
            onClick={() => handleDelete(row.original.id)}
            style={{
              padding: "6px 12px",
              backgroundColor: "#ef4444",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "13px",
              fontWeight: "500",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#dc2626";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#ef4444";
            }}
          >
            حذف
          </button>
        </div>
      ),
    },
  ];

  // حساب المجموع الكلي
  const totalAmount = expenseInvoices.reduce(
    (sum, invoice) => sum + parseFloat(invoice.amount),
    0
  );

  return (
    <div className="expense-invoices-page">
      <div className="page-container">
        <div className="page-header">
          <div>
            <h2 className="page-title">
              فواتير الصرف ({expenseInvoices.length})
            </h2>
            <p className="total-amount">
              المجموع الكلي: <span>{totalAmount.toFixed(2)} ₪</span>
            </p>
          </div>
          <Link
            to="/expense-invoice/new"
            style={{
              backgroundColor: "#3b82f6",
              color: "white",
              padding: "8px 16px",
              borderRadius: "4px",
              fontWeight: 600,
              textDecoration: "none",
              display: "inline-block",
            }}
          >
            + إضافة فاتورة صرف
          </Link>
        </div>

        {loading ? (
          <p className="loading-text">جارٍ تحميل البيانات...</p>
        ) : (
          <div className="table-wrapper">
            <MaterialReactTable
              columns={columns}
              data={expenseInvoices}
              enableColumnResizing
              enableStickyHeader
              enablePagination
              muiTableContainerProps={{ sx: { maxHeight: "600px" } }}
              initialState={{
                pagination: { pageSize: 25, pageIndex: 0 },
                density: "comfortable",
              }}
              muiTableProps={{
                sx: {
                  tableLayout: "auto",
                },
              }}
              muiTableHeadCellProps={{
                sx: {
                  backgroundColor: "#eff6ff",
                  fontWeight: "bold",
                  fontSize: "0.95rem",
                  color: "#1e40af",
                },
              }}
              muiTableBodyCellProps={{
                sx: {
                  fontSize: "0.9rem",
                },
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ExpenseInvoices;
